import axios from 'axios';
import Auth from './Auth';
import History from './History';
import Helper from "./Helper";
import Storage from "./Storage";
import {STORE_KEY} from "../app/constants/store-key";
import {Modal, notification} from "antd";
import appConfigService from "./AppConfigService";

class API {
  get(endPoint: any, params: any, queryParams: any, config = {}) {
    endPoint = this.makeUrl(endPoint, params, queryParams);
    return this.makeRequest({
      method: 'GET',
      url: endPoint,
      ...config
    });
  }

  post(endPoint: any, data: any, params: any, queryParams: any) {
    endPoint = this.makeUrl(endPoint, params, queryParams);
    return this.makeRequest({
      method: 'POST',
      url: endPoint,
      data: data,
    });
  }

  makeRequest(config: any) {
    // const token = Auth.getToken();
    // const token = sessionStorage.getItem("authInformation")
    const token = Storage.getFromSession(STORE_KEY.authInformation);
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        'X-Request-ID': Helper.makeRequestId()
      };
    } else {
      config.headers = {
        'X-Request-ID': Helper.makeRequestId()
      };
    }

    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (!error.response) {
          error.response = {
            data: 'Network error',
            status: 500,
          };
        }
        // if (!error.response) {
        //   error.response = {
        //     data: '502 Bad Gateway',
        //     status: 502,
        //   };
        // }
        if (error.response.status === 405) {
          sessionStorage.clear();
          Auth.clearToken();
          History.push('/auth/login');
          throw error;
        }

        if (error.response.status === 401) {
          sessionStorage.clear();
          Auth.clearToken();
          History.push('/auth/login');
          History.go(0);
          // notification.warning({message: 'Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.', duration: 4});
          // Modal.error({title: 'Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.'})
          throw error;
        }

        return Promise.reject(error);
      },
    );
    config.baseURL = appConfigService.baseUrl;
    return axios(config);
  }

  makeUrl(endPoint: any, params: any, queryParams: any) {
    if (params && Object.keys(params).length) {
      Object.keys(params).forEach(key => {
        endPoint = endPoint.replace(`:${key}`, params[key]);
      });
    }
    if (queryParams && Object.keys(queryParams).length) {
      let index = 0;
      let query = '';
      for (const key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
          index++;
          if (index === Object.keys(queryParams).length) {
            query += `${key}=${queryParams[key]}`;
          } else {
            query += `${key}=${queryParams[key]}&`;
          }
        }
      }
      endPoint = `${endPoint}?${query}`;
    }
    return endPoint;
  }
}

export default new API();
